export default __webpack_public_path__ + "v1.18.25/static/media/LibreDataSharecode_Arabic.210c4f6c.svg";